
export const loginRequest = {
    scopes: ["User.ReadWrite"],
  };
  